export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 10;
export const OPENINGS_DEFAULT_PER_PAGE = 20;
export const PER_PAGE_VALUES = [10, 20, 30];
